export const defaultFallbackImagePath = (type: "sm" | "lg") => {
	return process.env.PUBLIC_URL + `/img/placeholder-${type}.jpg`;
};

/**
 * Using standard url definition for resizing, retrieves the original url from a given path if the resized version is not available
 * @param url the image path being retrieved
 * @returns the original path if a resized path, null otherwise
 */
export const getOriginalSizeUrl = (url: string): string | null => {
	const resizedPath = "/resized/";

	if (!url || !url.includes(resizedPath)) {
		return null;
	}

	// 1️⃣ Remove /resized/
	const withoutResized = url.replace(resizedPath, "/");

	// 2️⃣ Split path + filename
	const parts = withoutResized.split("/");
	const file = parts.pop();

	if (!file) {
		return null;
	}

	// 3️⃣ Extract filename parts
	// e.g. logo_png_avatar.jpg
	const match = file.match(/^(.+?)_([a-zA-Z0-9]+)\.[^.]+$/);
	if (!match) {
		return null;
	}

	const [, nameWithExt, typeSuffix] = match;

	// 4️⃣ Split name + original extension
	// logo_png → [logo, png]
	const lastUnderscore = nameWithExt.lastIndexOf("_");
	if (lastUnderscore === -1) {
		return null;
	}

	const baseName = nameWithExt.substring(0, lastUnderscore);
	const originalExt = nameWithExt.substring(lastUnderscore + 1);

	// 5️⃣ Rebuild original filename
	const originalFile = `${baseName}.${originalExt}`;

	return [...parts, originalFile].join("/");
};
